<rt-group
  rt-overlay-origin
  #candidateSelectDropdownOrigin="rtOverlayOrigin"
  variant="horizontal"
  layout-align-items-center
>
  @if (!value) {
    <rt-icon-button
      (click)="!readOnly() && toggleDropdown(true)"
      [pressed]="state.dropdownOpen"
      variant="outline"
      class="action"
      iconName="add"
      shape="round"
    />
  }
  @if (value) {
    <rt-button
      [disabled]="readOnly()"
      [pressed]="state.dropdownOpen"
      (click)="!readOnly() && toggleDropdown(true)"
      variant="plain"
      class="candidate-button"
    >
      <rt-candidates-multi-select-item
        [candidate]="value"
        [actOnClick]="false"
        [editable]="!readOnly()"
        layout-flex-1-0
      />
      <span overflow-hidden margin-left-small-x>
        <rt-truncate>
          {{ value.name }}
        </rt-truncate>
      </span>
    </rt-button>
    @if (!readOnly()) {
      <rt-icon-button
        (click)="valueChange.emit(undefined)"
        variant="plain"
        iconName="close"
        shape="square"
      />
    }
  }
</rt-group>

<ng-template
  rt-connected-overlay
  [rtConnectedOverlayAutoClose]="false"
  [positions]="dropdownConfig"
  rtDropdownConfig="dropdownConfig"
  [hasBackdrop]="true"
  [origin]="candidateSelectDropdownOrigin"
  [open]="state.dropdownOpen"
  (backdropClick)="toggleDropdown(false)"
>
  <rt-candidate-select-dropdown
    [emptyStateHeading]="'app.layout.candidate_select.task_empty_state.heading' | translate"
    [emptyStateSubheading]="'app.layout.candidate_select.task_empty_state.subheading' | translate"
    (selectCandidate)="valueChange.emit($event); toggleDropdown(false)"
    (close)="toggleDropdown(false)"
  />
</ng-template>
